<template>
  <a href="https://kimsa.io" target="_blank" class="dev-by-wrapper" >
    <span :class="['dev-by', {'dark': dark}]">Desarrollado por</span><v-img  :class="['mx-auto dev-logo', {'dark': dark}]" :src="require('@/assets/img/kimsa_logo.png')"/>
  </a>
</template>

<script>
export default {
  name: "DevByKimsa",
  props:{
    dark: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

   a{
     text-decoration: none;
   }

  .dev-by-wrapper{
    width: 220px;
    margin: auto;
  }

  .dev-by{
    font-family: Roboto, sans-serif;
    font-size: 13px;
    color: #000;
    margin-right: 8px;
    display: inline-block;
  }

  .dev-by.dark{
    color: #fff
  }

  .dev-logo{
    display: inline-block;
    width: 70px;
  }

   .dev-logo.dark{
     filter: brightness(10);
   }


</style>